var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{class:_vm.buttonClass + ' d-print-none',style:(_vm.buttonStyle),on:{"click":function($event){return _vm.$emit('buttonInput')}}},[_vm._v("\n    "+_vm._s(_vm.buttonText)+"\n  ")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.urlLink}},[_c('button',{class:_vm.buttonClass + ' hidden-normal',style:(_vm.buttonStyle)},[_vm._v("\n      "+_vm._s(_vm.buttonText)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-348868dc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PDFButton.vue
// module id = 605
// module chunks = 38